import { useGetPermissions } from '@/queries/permissions/useGetPermissions'
import { usePermissionsActions } from '@/stores/permissions/permissions'
import { useEffect } from 'react'

export function usePermissionsFetcher() {
  const { data } = useGetPermissions()
  const { setPermissions } = usePermissionsActions()

  useEffect(() => {
    if (data) {
      setPermissions(data)
    }
  }, [setPermissions, data])
}
